<svelte:head>
		<meta property="og:title" content="아바톡 X 블라이스 AI챗 오픈기념 이벤트" />
		<meta property="og:description" content="블라이스 웹툰 캐릭터와 채팅하면 다양한 상품이 와르르!" />
		<meta property="og:image" content="https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/event/mrwulpgyef/%E1%84%87%E1%85%AE%E1%86%AF%E1%84%89%E1%85%A5%E1%86%AB.png" />
</svelte:head>
<script>
	import {onDestroy, onMount} from 'svelte';
	import {navigateTo} from 'svelte-router-spa';
	import {PRConnect} from "@projectroom/ui-lib";

	export let currentRoute;
	
	const EVENT_TYPE_RECOMMEND = "RECOMMEND";
	
	let eventInfo = {
	title : "",
	subTitle: "",
	content: "",
	notice: "",
	viewCount: "",
	endDate: "",
	startDate: "",
	resultDate: ""
	};
	const weekday = ["일", "월", "화", "수", "목", "금", "토"];
	const RANKING_VIEW_CONTENT = {
		"name" : "이름",
		"email" : "이메일",
		"phone" : "전화번호",
		"insta" : "인스타 주소"
	}
	let loginInfo = { "emailId" : "", "password" : ""};
	let eventRequireData = {insta : false , name : false, email : false, phone : false};
	let eventRequireInfo = {};
	let errorMessage = "";
	let currentTab = "tab1";
	let loginPopupFlag, eventParticipateFlag, applicantsCodeFlag;
	let applicantsCode;
	let copyMessage;
	let shareMessage;
	let rankingList = [];
	let agreementFlag;
	let refAggrement = [];
	let readOnlyFlag = false;
	let isDosubmit;
	let errorFlag;
	
	onMount(() => {
		const token = PRConnect.getCookie("x-token");
		PRConnect.send("/api/Event/getEvent", {id : eventId, token}, data => {
			if( data.header.status === "success") {
				eventInfo = data.result.event;
				JSON.parse(eventInfo.receiveContent).forEach((content)=> {
					eventRequireData[content] = true;
				});
				applicantsCode = data.result.applicant?.id;
			}
		});
		PRConnect.send("/api/Event/getRanking", { id : eventId }, data => {
			if( data.header.status === "success") {
				rankingList = data.result;
			}
		});
	});
	const eventId = currentRoute.namedParams.eventId;

	const clickCurrentTab = (e) => {
		currentTab = e.target.closest("a").dataset.tab;
	}

	const isOverResultDay = () => {
		return new Date(eventInfo.resultDate) <= new Date();
	}

	const isEarlierThanStartDate = () => {
		return new Date().getTime() <= new Date(eventInfo.startDate).getTime();
	}

	const isLaterThanEndDate = () => {
		return new Date().getTime() >= new Date(eventInfo.endDate).getTime();
	}

	const isBetweenEventPeriod = () => {
		return new Date().getTime() >= new Date(eventInfo.startDate).getTime() && new Date().getTime() < new Date(eventInfo.endDate).getTime();
	}

	const getEventPeriod = () => {
	return `${new Date(eventInfo.startDate).toLocaleDateString().substring(0,new Date(eventInfo.startDate).toLocaleDateString().length - 1)} (${weekday[new Date(eventInfo.startDate).getDay()]}) ~ ${new Date(eventInfo.endDate).toLocaleDateString().substring(0,new Date(eventInfo.endDate).toLocaleDateString().length - 1)} (${weekday[new Date(eventInfo.endDate).getDay()]})`;
	}

	const getResultDay = () => {
	return `${new Date(eventInfo.resultDate).toLocaleDateString().substring(0,new Date(eventInfo.resultDate).toLocaleDateString().length - 1)} (${weekday[new Date(eventInfo.resultDate).getDay()]})`;
	}

	const getRemainDays = () => {
		const reaminDays = Math.ceil((new Date(eventInfo.endDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
		return reaminDays > 0 ? `${reaminDays}일` : '종료';
	}

	const validEmail = () => {
		const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
		return loginInfo.emailId.match(regex) == null;
	}

	const doLogin = () => {
		if (validEmail()) {
			errorMessage = "이메일 형식이 잘못되었습니다.";
			return;
		}
		
		PRConnect.send("/api/Auth/login", loginInfo, data => {
			if( data.result.status === "success") {
				loginPopupFlag = false;
				eventParticipateFlag = true;
			} else if (data.result.status === "required") {
				navigateTo(`${data.result.targetUrl}?${data.result.authToken}`);
			}
		}, error => {
			if (error.header.code === "fail") {
				errorMessage = error.header.message;
			}
		});
	}

	const doSNSLogin = (provider) => {
		const userAgent = navigator.userAgent;
		if (userAgent.includes("KAKAO") || userAgent.includes("Instagram")) {
			alert("인스타/카카오톡 브라우저에서는 구글 가입 및 로그인이 불가능합니다. PC 또는 모바일 브라우저로 재시도 부탁드립니다.");
			return;
		}
		switch(provider) {
			case "google": 
			location.href =
			`https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${location.origin}/auth/callback/google&prompt=consent&response_type=code&state=event/${eventId}&client_id=478826573645-0ahmehhpvmq053jh27c4p646bgak3b8s.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile`;
			break;
		case "kakao": 
			location.href =
			`https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=dc3054523b05087d5f4582c876e1d3b9&redirect_uri=${location.origin}/auth/callback/kakao&state=event/${eventId}`;
			break;
		}
	}

	const doEventSubmit = () => {
		const privacyContent = JSON.stringify(eventRequireInfo);
		if(!refAggrement[0].checked || !refAggrement[1].checked){
			agreementFlag = true;
			return;
		}
		isDosubmit = true;
		PRConnect.send("/api/Event/applyEvent", {privacyContent, eventId}, data => {
			if( data.header.status === "success") {
				eventParticipateFlag = false;
				if (eventInfo.eventType === EVENT_TYPE_RECOMMEND) {
					applicantsCode = data.result.applicantsCode;
					applicantsCodeFlag = true;
				}
			}
		}, error => {
			if (error.header.code === "IS_PHONE_NUMBER_DUPLICATED") {
				errorFlag = true;
				eventParticipateFlag = false;
				isDosubmit = false;
				errorMessage = error.header.message;
			}
		});
	}

	const clickEventParticipate = () => {
		if (eventInfo.eventType === EVENT_TYPE_RECOMMEND) {
			const token = PRConnect.getCookie("x-token");
			if (!token) {
				loginPopupFlag = true;
				return;
			}
			if (applicantsCode) {
			applicantsCodeFlag = true;
			return;
			}
			PRConnect.send("/api/Event/getApplicant", { eventId }, data => {
				if( data.header.status === "success") {
					applicantsCode = data.result.applicant?.code;
					if (!applicantsCode) {
						eventRequireInfo = data.result.userInfo;
						readOnlyFlag = true;
						eventParticipateFlag = true;
					} else {
						applicantsCodeFlag = true;
					}
				}
			});
		} else {
			eventParticipateFlag = true;
		}
	}
	
	const copyApplicantsCode = () => {
		const statePharase = 	applicantsCode ? `?state=${applicantsCode}` : '';
		const url = `${location.origin}/join${statePharase}`;
		window.navigator.clipboard.writeText(url);
		copyMessage = true;
		setTimeout(()=>{
			applicantsCodeFlag = false;
			copyMessage = false;
		}, 2000)
	}

	const clickEventShare = () => {
		const url = `${location.href}`;
		window.navigator.clipboard.writeText(url);
		shareMessage = true;
		setTimeout(() => {
			shareMessage = false;
		}, 2000);
	}

	const changeAggrement = () => {
		if(refAggrement[0].checked && refAggrement[1].checked){
			agreementFlag = false;
		}
	}

	const onKeydown = (e) => {
		if (e.code === "Enter") {
			doLogin();
		}
	}

	const clickEventLink = () => {
		const link = eventInfo.popupLink;
        window.open(link);
	}
</script>
<div class="ava-event">
{#if eventInfo.startDate}
	<div class="event-title _2">
		<div class="e-title">
		<strong class="bold-text-7">{eventInfo.title}</strong></div>
	</div>
	<div class="event-sub">
		<div class="e-sub">{eventInfo.subTitle}</div>
	</div>
	<div class="eventdetail-con-wrap">
		<div class="eventdetail-con">
		<div data-current="Tab 2" data-easing="ease" data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<div class="tabs-menu w-tab-menu" on:click={clickCurrentTab}>
			<a data-tab="tab1" class="tab-link-tab-1 w-inline-block w-tab-link" class:w--current={currentTab === "tab1"} id="w-tabs-0-data-w-tab-0" role="tab" aria-controls="w-tabs-0-data-w-pane-0" aria-selected="true">
				<div>이벤트 정보</div>
			</a>
			{#if eventInfo.eventType === "RECOMMEND" && eventInfo.rankingFlag === "Y"}
			<a data-tab="tab2" class="tab-link-tab-2 w-inline-block w-tab-link" class:w--current={currentTab === "tab2"} id="w-tabs-0-data-w-tab-1" role="tab" aria-controls="w-tabs-0-data-w-pane-1" aria-selected="false" tabindex="-1">
				<div>실시간 랭킹</div>
			</a>
			{/if}
			{#if isOverResultDay() && eventInfo.resultContent}
			<a data-tab="tab3" class="tab-link-tab-3 w-inline-block w-tab-link" class:w--current={currentTab === "tab3"} tabindex="-1" id="w-tabs-0-data-w-tab-2" role="tab" aria-controls="w-tabs-0-data-w-pane-2" aria-selected="false">
				<div>결과발표</div>
			</a>
			{/if}
			</div>
			<div class="tabs-content w-tab-content">
			<div data-w-tab="Tab 1" class="w-tab-pane " class:w--tab-active={currentTab === "tab1"} id="w-tabs-0-data-w-pane-0" role="tabpanel" aria-labelledby="w-tabs-0-data-w-tab-0" >
				<div class="event-info-wrap">
					<img src={eventInfo.mainImageContent} loading="lazy" class="event-info-image" />
					<div class="event-info-text-wrap">
						<div class="event-info-text">
						<div class="e-title-text"><strong class="bold-text-7">이벤트 안내</strong></div>
						<div class="e-sub-text">{@html eventInfo.content}</div>
						</div>
					</div>
					<div class="event-info-note-wrap">
						<div class="e-note-text"><strong>유의사항</strong></div>
						<div class="e-sub-note">{@html eventInfo.notice}</div>
					</div>
				</div>
			</div>
			{#if eventInfo.eventType === "RECOMMEND" && eventInfo.rankingFlag === "Y"}
			<div data-w-tab="Tab 2" class="w-tab-pane" class:w--tab-active={currentTab === "tab2"} id="w-tabs-0-data-w-pane-1" role="tabpanel" aria-labelledby="w-tabs-0-data-w-tab-1" style="" >
				<div class="event-lanking-wrap">
				<div class="e-title-text"><strong class="bold-text-7">실시간 랭킹 순위</strong></div>
				<div class="event-lankingboard-wrap-copy">
					<div class="event-lankingboard">
					<div class="lanking-title">
						<div class="lanking-title-text">순위</div>
						<div class="lanking-title-text email">이메일</div>
						<div class="lanking-title-text">추천인 수</div>
					</div>
					{#each rankingList as ranking}
					<div class="lanking-con">
						<div class="lanking-title-text">{ranking.ranking}</div>
						<div class="lanking-title-text email">{ranking.email}</div>
						<div class="lanking-title-text violet">{ranking.cnt}</div>
					</div>
					{/each}
					</div>
				</div>
				</div>
			</div>
			{/if}
			{#if isOverResultDay() && eventInfo.resultContent}
			<div data-w-tab="Tab 3" class="w-tab-pane" class:w--tab-active={currentTab === "tab3"} role="tabpanel" aria-labelledby="w-tabs-0-data-w-tab-2" >
				<div class="event-info-text-wrap">
					<div class="event-result-text">
						<div class="e-title-text"><strong class="bold-text-7">이벤트 결과</strong></div>
						<img src={eventInfo.resultMainImageContent} loading="lazy" class="event-info-image" />
						<div class="e-sub-text">{@html eventInfo.resultContent}</div>
					</div>
					<div class="event-info-note-wrap">
						<div class="e-note-text violet"><strong>유의사항</strong></div>
						<div class="e-sub-note">{@html eventInfo.resultNotice}</div>
					</div>
				</div>
			</div>
			{/if}
			</div>
		</div>
		</div>
		<div class="eventdetail-guide">
		<div class="event-date-wrap">
			<div class="event-date">
			<div class="event-date-title">이벤트 기간</div>
			<div class="event-date-data">{getEventPeriod()}</div>
			</div>
			{#if eventInfo.resultDate}
			<div class="event-date">
				<div class="event-date-title">결과 발표일</div>
				<div class="event-date-data">{getResultDay()}</div>
			</div>
			{/if}
		</div>
		<div class="event-figure">
			<div class="event-date">
			<div class="event-figure-title">남은 기간</div>
			<div class="event-figure-data">{getRemainDays()}</div>
			</div>
			<div class="event-date">
			<div class="event-figure-title">조회수</div>
			<div class="event-figure-data">{eventInfo.viewCount}건</div>
			</div>
		</div>
		<div class="event-btn">
			{#if isBetweenEventPeriod()}
				{#if eventInfo.eventType === "LINK"}
				<div class="event-button" on:click={clickEventLink}>{eventInfo.popupTitle || "이벤트 참여하기"}</div>
				{:else}
				<div class="event-button" on:click={clickEventParticipate}>이벤트 참여하기</div>
				{/if}
			{:else}
				{#if eventInfo.eventType === "LINK"}
				<div class="event-button deadline">이벤트 참여하기</div>
				{:else}
				<div class="event-button deadline">이벤트 참여하기</div>
				{/if}
			{/if}
			{#if eventInfo.eventShareFlag === "Y"}
			<div class="event-share-button" on:click={clickEventShare}>이벤트 공유하기
				{#if shareMessage}
				<div class="link-copy-share"><span>링크가 복사되었습니다.</span></div>
				{/if}
			</div>
			{/if}
		</div>
		</div>
	</div>
	{/if}
	</div>
	<div class="event-popup" class:show={eventParticipateFlag} on:click={()=> eventParticipateFlag = false}>
	<div class="popup-layer image-upload-pop" on:click|stopPropagation>
		<div class="h1-light">{eventInfo.popupTitle || "이벤트"}</div>
		<div class="x-button" on:click={()=> eventParticipateFlag = false}></div>
		<div class="a-event-form">
		<div class="w-form">
			<div id="email-form" name="email-form" class="a-event-input-form">
			{#if eventRequireData.insta}
			<label for="name-3" class="field-label-2">인스타그램 주소 (확인용으로 필요합니다.)</label>
			<input type="email" class="phone-number w-input" maxlength="256" bind:value={eventRequireInfo.insta} name="name-3" data-name="Name 3" placeholder="예) https://www.instagram.com/avatalk.official/" id="name-3">
			{/if}
			{#if eventRequireData.name}
			<label for="name-3" class="field-label-2">성함</label>
			<input type="email" class="phone-number w-input" maxlength="256" bind:value={eventRequireInfo.name} name="name-2" data-name="Name 2" placeholder="예) 홍길동" id="name-2">
			{/if}
			{#if eventRequireData.email}
			<label for="name-3" class="field-label-2">이메일</label>
			<input type="email" class="phone-number w-input" maxlength="256" bind:value={eventRequireInfo.email} name="name-2" data-name="Name 2" placeholder="예) abcde@gmail.com" id="name-2" readonly={readOnlyFlag}>
			{/if}
			{#if eventRequireData.phone}
			<label for="name-3" class="field-label-2">전화번호</label>
			<input type="email" class="phone-number w-input" maxlength="256" bind:value={eventRequireInfo.phone} name="name-2" data-name="Name 2" placeholder="'-' 없이 번호만입력해주세요!" id="name-2" readonly={readOnlyFlag}>
			{/if}
			<label class="w-checkbox checkbox-field">
				<input type="checkbox" bind:this={refAggrement[0]} required="" on:change={changeAggrement}>
				<span class="checkbox-label w-form-label">아바톡 <a href="https://phantom-cap-f7c.notion.site/d58aaaedee164364a7a74eb98181d036" target="_blank">이용약관</a> 및 <a href="https://phantom-cap-f7c.notion.site/7ccdf3b4e75b412a89a76a3daaa76509" target="_blank">개인정보 처리 방침</a> 동의</span>
			</label>
			<label class="w-checkbox checkbox-field">
				<input type="checkbox" bind:this={refAggrement[1]} required="" on:change={changeAggrement}>
				<span class="checkbox-label w-form-label"><a href="https://phantom-cap-f7c.notion.site/36d49e46c40d4566aa868f710990bb57" target="_blank">마케팅 활용 및 광고성 정보 수신</a> 동의</span>
			</label>
			<div class="privacy-required-text" class:show={agreementFlag}>개인정보 수집 및 이용 동의란에 체크하셔야합니다.</div>
			{#if isDosubmit}
				{#if eventInfo.eventType === "RECOMMEND"}
				<input type="submit" value="추천인 링크 부여받기" data-wait="Please wait..." class="submit-button w-button do-submit">
				{:else}
				<input type="submit" value="이벤트 참여하기" data-wait="Please wait..." class="submit-button w-button do-submit">
				{/if}
			{:else}
				{#if eventInfo.eventType === "RECOMMEND"}
				<input type="submit" value="추천인 링크 부여받기" data-wait="Please wait..." class="submit-button w-button" on:click={doEventSubmit}>
				{:else}
				<input type="submit" value="이벤트 참여하기" data-wait="Please wait..." class="submit-button w-button" on:click={doEventSubmit}>
				{/if}
			{/if}
			</div>
		</div>
		</div>
	</div>
	</div>
	<div class="event-login-popup" class:show={loginPopupFlag} on:click={()=> loginPopupFlag = false}>
	<div class="popup-layer image-upload-pop" on:click|stopPropagation>
		<div class="x-button" on:click={()=> loginPopupFlag = false}></div>
		<div class="join-section-event">
		<div class="h1">로그인</div>
		{#if errorMessage }
			<div class="error">{errorMessage}</div>
		{/if}
		<div class="join-email">
			<div class="w-form">
			<div id="email-form" name="email-form" data-name="Email Form" aria-label="Email Form">
			<label for="name-4" class="field-label-3">이메일</label>
			<input type="email" class="phone-number-2 w-input" maxlength="256" name="name-4" data-name="Name 4" placeholder="이메일 주소를 입력하세요." id="name-4" bind:value={loginInfo.emailId}>
			<label for="email" class="field-label-3">비밀번호</label>
			<input type="password" class="text-field w-input" maxlength="256" name="email" data-name="Email" placeholder="특수문자, 문자, 숫자 포함한 8자 이상" id="email" required="" bind:value={loginInfo.password} on:keydown={onKeydown}>
				<div class="find-personal-data">
				<a href="#" class="find-email-link" on:click={()=>navigateTo("/find-email")}><span class="text-span-2">가입된 이메일 찾기</span></a>
				<a href="#" class="find-password-link" on:click={()=>navigateTo("/find-password")}><span class="text-span-2">비밀번호 찾기</span></a>
				</div><input type="submit" value="로그인 하기" data-wait="Please wait..." class="submit-button-2 w-button" on:click={doLogin}>
			</div>
			</div>
		</div>
		<div class="or">
			<div class="or-line-l"></div>
			<div class="or-text">Or</div>
			<div class="or-line-r"></div>
		</div>
		<a href="#" class="join-sns-button google w-button" on:click={()=> doSNSLogin("google")}>구글 계정으로 로그인</a>
		<a href="#" class="join-sns-button kakao w-button" on:click={()=> doSNSLogin("kakao")}>카카오 계정으로 로그인</a>
		<a href="#" class="join-link" on:click={()=>navigateTo("/join")}>처음이신가요?<span class="text-span-2">가입하기</span></a>
		</div>
	</div>
	</div>
	<div class="eventlink-popup" class:show={applicantsCodeFlag} on:click={()=> applicantsCodeFlag = false}>
	<div class="popup-layer image-upload-pop" on:click|stopPropagation>
		<div class="h1-light margin20">추천인 링크를 부여해드렸습니다!<br>친구에게 링크를 공유해서 이벤트에 참여해보세요!</div>
		<div class="x-button _2" on:click={()=> applicantsCodeFlag = false}></div>
		<div class="a-event-form">
		<div class="w-form">
			<div id="email-form" name="email-form" data-name="Email Form" method="get" class="a-event-input-form link-copy-form" aria-label="Email Form">
			<input type="submit" value="추천인 링크 복사하기" data-wait="Please wait..." class="submit-button w-button" on:click={copyApplicantsCode}>
			{#if copyMessage}
			<div class="link-copy-context"><span>링크가 복사되었습니다.</span></div>
			{/if}
			</div>
		</div>
		</div>
	</div>
	</div>
	<div class="eventlink-popup" class:show={errorFlag} on:click={()=> errorFlag = false}>
	<div class="popup-layer image-upload-pop" on:click|stopPropagation>
		<div class="h1-light margin20">{errorMessage}</div>
		<div class="x-button _2" on:click={()=> errorFlag = false}></div>
	</div>
	</div>

<style>
	.ava-event {
	min-height: 1300px;
	}
	.w-tab-link {
		background-color: #f8f8fa;
	}
	.tabs {
		height: 100%;
		padding-left: 0px;
	}
	.tabs-menu {
		margin: 0px;
	}

	.w-tab-link {
		margin: 0px;
	}
	.tab-link-tab-1.w--current {
		width: auto;
	}

	.tabs-content {
		overflow: hidden;
		height: auto;
	}
	.w--tab-active {
		opacity: 1; 
		transition: opacity 300ms ease 0s;
	}
	.lanking-title-text.violet {
		color: #7462e6;
		text-align: center;
	}
	.error {
		font-weight: bold;
		font-size: 14px;
		color: red;
		text-align: center;
		margin: 10px 0px;
	}
	.event-popup {
		position: fixed;
	}
	.event-btn div {
		cursor: pointer;
	}

	.link-copy-form {
		position: relative;
	}

	.link-copy-context {
		margin: 8px;
		color: #fff;
		text-align: center;
		border-radius: 6px;
		background-color: #423f3f;
		font-family: "Noto sans kr 400", sans-serif;
		font-size: 10px;
		line-height: 12px;
		font-weight: 400;
		padding: 6px 10px;
		position: absolute;
		z-index: 1;
		right: 144px;
		top: 62px;
	}

	.event-share-button {
		position: relative;
	}

	.link-copy-share {
		margin: 8px;
		color: #fff;
		text-align: center;
		border-radius: 6px;
		background-color: #423f3f;
		font-family: "Noto sans kr 400", sans-serif;
		font-size: 10px;
		line-height: 12px;
		font-weight: 400;
		padding: 6px 10px;
		position: absolute;
		z-index: 1;
		right: 70px;
		top: 54px;
	}

	.w-checkbox {
		padding-left: 0px;
	}
	.checkbox-field {
		display: flex;
		align-items: center;
	}
	
	.checkbox-field span{
		margin-left: 7px;
	}

	.privacy-required-text {
		text-align: center;
		font-size: 12px;
		color: red;
		font-weight: 700;
		display: none;
	}

	.deadline {
		background-color: gray;
	}
	.eventdetail-guide {
		width: auto;
	}

	.w-checkbox a {
		color: inherit;
	}
	.bold-text-7 {
		font-size: 30px;
	}
	.e-title-text {
		margin-left: 0px;
		margin-right: 0px;
	}

	.e-sub-text {
		line-height: 30px;
	}
	.do-submit {
		background-color: whitesmoke;
	}

	.tab-link-tab-1 {
		font-size: 30px
	}

	.tab-link-tab-2 {
		font-size: 30px
	}

	.tab-link-tab-3 {
		font-size: 30px
	}

	.w-tab-link {
		padding: 30px;
	}
	.event-lankingboard {
		overflow: auto;
	}

	@media screen and (max-width: 479px) {
		.e-title {		
			margin-bottom: 20px;	
			line-height: 40px;
		}

	 	.e-sub {
			line-height: 26px;
		}
	}
	@media screen and (max-width: 767px) {
		.tab-link-tab-1 {
			font-size: 16px
		}

		.tab-link-tab-2 {
			font-size: 16px
		}

		.tab-link-tab-3 {
			font-size: 16px
		}
		.w-tab-link {
			padding: 10px;
		}
	}
</style>